import { render } from "./Sensors.vue?vue&type=template&id=ff6b34c2&scoped=true&ts=true"
import script from "./Sensors.vue?vue&type=script&lang=ts"
export * from "./Sensors.vue?vue&type=script&lang=ts"

import "./Sensors.vue?vue&type=style&index=0&id=ff6b34c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6b34c2"]])

export default __exports__